module.exports = __webpack_public_path__ + "static/media/set3.4bc45b28.png";